import React from "react";
import { Card, CardBody, Col, FormGroup, Input, Label } from "reactstrap";
import { Controller } from "react-hook-form";
import { useDataFetch } from "../../Hooks/Use-data-fetch";

export const DataBasicForm = ({ control, errors }) => {
  const { getData } = useDataFetch();
  const { data: dataCategories, isLoading: loadingCategories } = getData(
    ["categories"],
    "/product/all/categories"
  );

  return (
    <Col xxl="5">
      <Card className="h-100">
        <CardBody style={{ maxHeight: "600px", overflowY: "auto" }}>
          {/* Título */}
          <FormGroup>
            <Label>Título</Label>
            <Controller
              name="title"
              control={control}
              rules={{ required: "El título es obligatorio" }}
              render={({ field }) => <Input type="text" {...field} />}
            />
            {errors.title && (
              <span className="text-danger small">{errors.title.message}</span>
            )}
          </FormGroup>

          {/* Categoría */}
          <FormGroup>
            <Label>Categoría</Label>
            <Controller
              name="category"
              control={control}
              rules={{ required: "La categoría es obligatoria" }}
              render={({ field }) => (
                <Input type="select" {...field}>
                  <option value="">Selecciona una categoría</option>
                  {loadingCategories ? (
                    <option>Cargando...</option>
                  ) : (
                    dataCategories?.data?.categories.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.name}
                      </option>
                    ))
                  )}
                </Input>
              )}
            />
            {errors.category && (
              <span className="text-danger small">{errors.category.message}</span>
            )}
          </FormGroup>

          {/* Short Description */}
          <FormGroup>
            <Label>Descripción corta</Label>
            <Controller
              name="shortDescription"
              control={control}
              rules={{ required: "La descripción corta es obligatoria" }}
              render={({ field }) => (
                <Input type="textarea" rows={2} {...field} />
              )}
            />
            {errors.shortDescription && (
              <span className="text-danger small">
                {errors.shortDescription.message}
              </span>
            )}
          </FormGroup>

          {/* Long Description */}
          <FormGroup>
            <Label>Descripción larga</Label>
            <Controller
              name="longDescription"
              control={control}
              rules={{ required: "La descripción larga es obligatoria" }}
              render={({ field }) => (
                <Input type="textarea" rows={4} {...field} />
              )}
            />
            {errors.longDescription && (
              <span className="text-danger small">
                {errors.longDescription.message}
              </span>
            )}
          </FormGroup>
        </CardBody>
      </Card>
    </Col>
  );
};
